import { IFoThucDonInsertItemRequest } from "../../../models/request/thuc-don/IFoThucDonInsertItemRequest";
import { IFoThucDonItemRequest } from "../../../models/request/thuc-don/IFoThucDonItemRequest";
import { IFoThucDon, IFoThucDonTheoNgayVm, IFoThucDonVm } from "../../../models/response/thuc-don/IFoThucDon";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export const objThucDonDefine = {
    LOAD_START: undefined,
    LOAD_SUCCESS: [] as IFoThucDon[],
    LOAD_ERROR: "",
    LOAD_COSO_START: 0,
    LOAD_COSO_SUCCESS: [] as IFoThucDonVm[],
    LOAD_COSO_ERROR: "",
    LOAD_THEO_NGAY_START: {} as IFoThucDonItemRequest,
    LOAD_THEO_NGAY_SUCCESS: [] as IFoThucDonTheoNgayVm[],
    LOAD_THEO_NGAY_ERROR: "",
    SHOW_EDIT_MODAL: {} as IFoThucDon | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as IFoThucDon,
    SAVE_SUCCESS: {} as IFoThucDon,
    SAVE_ERROR: "",
    INSERT_MULTIPLE_START: {} as IFoThucDonInsertItemRequest,
    INSERT_MULTIPLE_SUCCESS: [] as IFoThucDonInsertItemRequest[],
    INSERT_MULTIPLE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",
    SHOW_IMPORT_MODAL: undefined,
    CLOSE_IMPORT_MODAL: undefined,
};

export const eFoThucDonActionTypeIds = generateActionTypeIds(objThucDonDefine, "THUC_DON")
export type IFoThucDonActionTypes = IGenericActionType<typeof objThucDonDefine, "THUC_DON">
